module.exports = __webpack_public_path__ + "img/mhtit5.e78c1982.png";